module.exports = __webpack_public_path__ + "static/media/IlotF_synthese_5.dac4ae3d.webp";